import { useEffect, useState } from 'react'
import PageHeader from '../../Components/PageHeader/PageHeader'
import AppInput from '../../Components/AppInput/AppInput'
import { useDispatch, useSelector } from 'react-redux';
import { User } from 'lucide-react';
import { genderOptions } from '../../Constant/Options';
import AppSelect from '../../Components/AppSelect/AppSelect';
import AppButton from '../../Components/AppButton/AppButton';
import { UserValidationScheema } from '../../ValidationScheema/UserValidation';
import { hasError } from '../../utils';
import { setApiErrorJson, setApiJson } from '../../Redux/Actions/ApiAction';
import { ApiHit } from '../../Api/ApiHit';
import { register, updateUser, searchRole, searchBook } from '../../Constant/Constant';
import toast from 'react-hot-toast';
import MultiSelect from '../../Components/AppSelect/MultiSelect';
import { getCahbookUser } from '../../Storage/Storage';

function AddUser({ isEditMode, onClose, userData }) {

  console.log("userData",userData);
  

  
  const ApiReducer = useSelector((state) => state.ApiReducer);
  const dispatch = useDispatch();
  const [roleOptions, setRoleOptions] = useState([]);
  const [bookOptions, setBookOptions] = useState([]);
  const [accountOptions, setAccountoptions] = useState([]);

  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    fetchRoles();
    fechAccounts()
  }, []);

  // Fetch books when accountId changes
  useEffect(() => {
    if (ApiReducer?.apiJson?.accountId && ApiReducer?.apiJson?.accountId?.length > 0) {
      fetchBooks();
    } else {
      setBookOptions([]); // Clear books if no account selected
      dispatch(setApiJson({ ...ApiReducer?.apiJson, bookId: [] })); // Clear selected books
    }
  }, [ApiReducer?.apiJson?.accountId]);

  useEffect(() => {
    if (isEditMode && userData) {
      const normalizedData = {
        ...userData,
        roleId: userData.roleId?._id || userData.roleId,
        bookId: userData.bookId?._id || userData.bookId
      };

      dispatch(setApiJson(normalizedData));
    }
  }, [isEditMode, userData, dispatch]);

  const fetchRoles = async () => {
    try {
      const json = {
        page: 1,
        limit: 50,
        search: {}
      };
      const res = await ApiHit(json, searchRole);

      if (res && res.data.docs && Array.isArray(res.data.docs)) {
        const options = res.data.docs.map(role => ({
          value: role._id,
          label: role.roleName
        }));
        setRoleOptions(options);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchBooks = async () => {
    try {
      // Get selected account IDs
      const selectedAccountIds = ApiReducer?.apiJson?.accountId || [];

      // Only fetch books if at least one account is selected
      if (selectedAccountIds.length === 0) {
        setBookOptions([]);
        return;
      }

      const json = {
        page: 1,
        limit: 100,
        search: {
          accountId: selectedAccountIds // Send array of selected account IDs
        }
      };
      const res = await ApiHit(json, searchBook);

      if (res && res.data.docs && Array.isArray(res.data.docs)) {
        const options = res.data.docs
          .filter(book => book.status === true) // Only active books
          .map(book => ({
            value: book._id,
            label: book.bookName
          }));
        setBookOptions(options);
      }
    } catch (error) {
      console.error("Error fetching books:", error);
      setBookOptions([]);
    }
  };

  const fechAccounts = async () => {

    let accounts = getCahbookUser()?.accountId
         const options = accounts.map(account => ({
          value: account._id,
          label: account.accountName
        }));
        setAccountoptions(options)
  };
  const handleSubmit = () => {
    setSubmitLoading(true);
    UserValidationScheema(ApiReducer?.apiJson, isEditMode).then((error) => {
      console.log("error",error);
      dispatch(setApiErrorJson(error))
      if (Object.keys(error).length === 0) {
        const apiEndpoint = isEditMode ? updateUser : register;
        const apiData = isEditMode
          ? { ...ApiReducer?.apiJson, _id: userData?._id }
          : ApiReducer?.apiJson;

        ApiHit(apiData, apiEndpoint).then((res) => {
          console.log("res", res);
          const successCode = isEditMode ? 200 : 201;
          if (res?.statusCode === successCode) {
            toast.success(isEditMode ? 'User updated successfully' : 'User added successfully');
            onClose()
          }
          else {
            toast.error(res?.error || 'Something went wrong')
          }
        }).finally(() => {
          setSubmitLoading(false);
        })
      } else {
        setSubmitLoading(false);
      }

    })
  }
  return (
    <div className='p-5'>
      <PageHeader
        title={isEditMode ? 'Edit User' : 'Add User'}
        description={isEditMode ? 'Update user information and account details' : 'Create a new user and manage their account'}
      />
      <div className='grid grid-cols-2 gap-x-4'>
        <AppInput
          title="Full Name"
          placeholder="Enter full name"
          name="name"
          important={true}
          error={hasError('name', ApiReducer)}
          icon={<User size={18} />}
          disabled={submitLoading}
        />
        <AppInput
          title="Email"
          placeholder="Enter email address"
          name="email"
          important={true}
          error={hasError('email', ApiReducer)}
          type="email"
          disabled={submitLoading}
        />

        <AppInput
          title="Contact Number"
          placeholder="Enter contact number"
          name="phone"
          important={true}
          error={hasError('phone', ApiReducer)}
          disabled={submitLoading}
        />
        <AppSelect
          title="Role"
          name="roleId"
          options={roleOptions}
          placeholder="Select role"
          error={hasError('roleId', ApiReducer)}
          disabled={submitLoading}
        />
        <MultiSelect
          title="Account"
          name="accountId"
          options={accountOptions}
          placeholder="Select account first"
          error={hasError('accountId', ApiReducer)}
          disabled={submitLoading}
          important={true}
        />
        <MultiSelect
          title="Book"
          name="bookId"
          options={bookOptions}
          placeholder={
            !ApiReducer?.apiJson?.accountId || ApiReducer?.apiJson?.accountId?.length === 0
              ? "Select account first"
              : "Select book"
          }
          error={hasError('bookId', ApiReducer)}
          disabled={submitLoading || !ApiReducer?.apiJson?.accountId || ApiReducer?.apiJson?.accountId?.length === 0}
        />
        <AppSelect
          title="Gender"
          name="gender"
          options={genderOptions}
          placeholder="Select gender"
          disabled={submitLoading}
        />
        {!isEditMode && (
          <div >
            <AppInput
              title="Password"
              placeholder="Enter password"
              name="password"
              error={hasError('password', ApiReducer)}
              important={true}
              disabled={submitLoading}
            />
          </div>
        )}
      </div>

      <div className='mt-5 flex justify-end'>
        <AppButton
          buttontext={submitLoading ? "Processing..." : (isEditMode ? "Update User" : "Add User")}
          onClick={handleSubmit}
          disabled={submitLoading}
        />
      </div>
    </div>
  )
}

export default AddUser
